/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Confirm_StudentInputs */

const en_confirm_student = /** @type {(inputs: Confirm_StudentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Student`)
};

const he_confirm_student = /** @type {(inputs: Confirm_StudentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`תלמיד`)
};

/**
* | output |
* | --- |
* | "Student" |
*
* @param {Confirm_StudentInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const confirm_student = /** @type {((inputs?: Confirm_StudentInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Confirm_StudentInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_confirm_student(inputs)
	return he_confirm_student(inputs)
});